/**
 * src/components/footer/FooterBrand.js
 *
 * Logo, tagline y datos de contacto del footer.
 * Props: { src, alt, name, tagline, contact: Array<{ icon, label, href }> }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('FooterBrand', ({ src, alt, name, tagline, contact = [] }) => {
    const contactEls = contact.map(({ icon, label, href }) =>
        h('a', { className: 'footer-brand__contact-item', href, target: '_blank', rel: 'noopener' },
            h('span', { className: 'footer-brand__contact-icon' }, icon),
            label
        )
    )

    return h('div', { className: 'footer-brand' },
        h('div', { className: 'footer-brand__logo' },
            h('img', { src, alt, className: 'footer-brand__img' }),
            ...(name ? [h('strong', { className: 'footer-brand__name' }, name)] : [])
        ),
        h('p', { className: 'footer-brand__tagline' }, tagline),
        h('div', { className: 'footer-brand__contacts' }, ...contactEls)
    )
})
